import { KnownPricePaymentMethod } from '@modules/ticket-fares-store';

export interface ISearchTicketDetails {
  id: number;
  title: string;
  alias: string;
  price: number;
  dailyPrice: number;
  subtitle: string;
  isDirectDebit: boolean;
  paymentMethod: KnownPricePaymentMethod;
  termDateFrom: string;
  termDateTo: string;
}

export interface ISearchTicketResult {
  description: {
    customerType: string;
    travelMethod: string;
    zone: string;
    title: string;
  };
  standardTicket: ISearchTicketDetails;
}

export interface ISearchTicketDetailsWithQty extends ISearchTicketDetails {
  count: number;
}
export interface ISearchTicketResultWithQty extends ISearchTicketResult {
  standardTicket: ISearchTicketDetailsWithQty;
}
